function calculateCheckDigit(barcode) {
  var sum = 0;
  for (let i = barcode.length - 1; i >= 0; i -= 2) {
    sum += parseInt(barcode[i]);
  }
  sum *= 3;
  for (let i = barcode.length - 2; i >= 0; i -= 2) {
    sum += parseInt(barcode[i]);
  }
  var remainder = sum % 10;
  var checkDigit = remainder === 0 ? 0 : 10 - remainder;
  return checkDigit;
}

function isNumeric(barcode) {
  return /^\d+$/.test(barcode);
}

export function isBarcodeValid(barcode) {
  if (barcode === "无") {
    return true;
  }
  if (!isNumeric(barcode)) {
    return false;
  }
  var checkDigit = parseInt(barcode.slice(-1));
  var calculatedCheckDigit = calculateCheckDigit(barcode.slice(0, -1));
  return checkDigit === calculatedCheckDigit;
}
